import { render, staticRenderFns } from "./_PostForm.vue?vue&type=template&id=515f704c&scoped=true&"
import script from "./_PostForm.vue?vue&type=script&lang=ts&"
export * from "./_PostForm.vue?vue&type=script&lang=ts&"
import style0 from "./_PostForm.vue?vue&type=style&index=0&id=515f704c&scoped=true&lang=scss&"
import style1 from "./_PostForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f704c",
  null
  
)

export default component.exports